import React from 'react'
import { CFView, CFImage, DefaultScreen, MobileScreen } from 'components'
import { promo1, promo2, promo3, promotions, mobilePromotion } from 'images'
import Slider from 'react-slick'

const settings = {
  infinite: true,
  speed: 500,
  arrows: false,
  slidesToScroll: 1,
  autoplay: true,
  autoplaySpeed: 2000,
  cssEase: 'linear',
  pauseOnHover: false,
  draggable: true,
  swipe: true,
}

export default () => {
  return (
    <CFView>
      <MobileScreen>
        <CFView column center m="0 auto" w="100%">
          <CFImage
            src={mobilePromotion}
            w="85%"
            alt="Promotions"
            mt="25px"
            mb="5px"
          />
        </CFView>
        <Slider {...{ ...settings, slidesToShow: 1 }}>
          <CFImage
            src={promo3}
            style={{ objectFit: 'contain' }}
            ph="15px"
            pb="20px"
          />
          <CFImage
            src={promo2}
            style={{ objectFit: 'contain' }}
            ph="15px"
            pb="20px"
          />
          <CFImage
            src={promo1}
            style={{ objectFit: 'contain' }}
            ph="15px"
            pb="20px"
          />
        </Slider>
      </MobileScreen>
      <DefaultScreen>
        <CFView column center maxWidth="1400px" m="35px auto" w="100%">
          <CFImage src={promotions} w="85%" alt="Promotions" />
        </CFView>
      </DefaultScreen>
    </CFView>
  )
}
